module.exports = __webpack_public_path__ + "img/image(1).a2d14311.png";